// extracted by mini-css-extract-plugin
export default {"products":"zs-z","card":"As-z","oosMessaging":"Bs-z"};